/**
 * Exported object of all our BroadcastChannel names.
 */

// [ ] TODO TAM clean: not needed (due to legacy dash linting)
/* eslint-disable */
export const PlayPositBroadcastChannels = Object.freeze({
  bulbControlsBroadcastChannel: 'playposit_bulbcontrols_channel',
  legacyDashBroadcastChannel: 'playposit_legacy_dash_channel',
});

export const PlayPositBroadcastChannelEventNames = Object.freeze({
  PEER_REVIEW_STUDENT_FEEDBACK_GIVEN: 'playposit__player__peer_review_bulb_complete_resync_feedback_data',
  LTI_LAUNCH: 'playposit__lti__launch_data',
});